import { useGetTagLink } from 'gen/client';

export function useGetTagRedirectLink(serial: string) {
    const {
        data: tagRedirectLink,
        error,
        isLoading,
        mutate,
    } = useGetTagLink(serial, {
        swr: {
            enabled: Boolean(serial),
            // Fetch only once: disable all automatic revalidations and retries.
            refreshInterval: 0,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            shouldRetryOnError: false,
        },
    });

    return { error, isLoading, mutate, tagRedirectLink };
}
